// Toggles an up/down caret for disclosing content
// For use with slideout. Finds the icon embedded
// in the link and flips it to the other version.
$('a[data-disclosure-toggle]').click(function () {
  $(this).find('span.fa-caret-down, span.fa-caret-up').toggleClass('fa-caret-down fa-caret-up');
});

$('[data-angle-toggle]').click(function () {
  $(this).find('.fa-angle-down, .fa-angle-up').toggleClass('fa-angle-down fa-angle-up');
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dom/disclosure-toggle.js